import AuthShell from "./AuthShell";
import AuthButtonLink from "./AuthButtonLink";
import a from "./auth.module.css";

export function RegistrationLinkLoading({ loginPath, backLabel = "Назад" }) {
  return (
    <AuthShell
      modern
      wide
      backTo={loginPath}
      backLabel={backLabel}
      showSwitcher={false}
      cardTitle="Заявка в клуб"
      hint="Загружаем данные ссылки…"
    >
      <div className={a.regLinkStateLoading} role="status" aria-live="polite">
        <span className={a.regLinkStateSpinner} aria-hidden />
        Подождите немного
      </div>
    </AuthShell>
  );
}

export function RegistrationLinkError({ message, loginPath, backLabel = "Назад" }) {
  return (
    <AuthShell
      modern
      wide
      backTo={loginPath}
      backLabel={backLabel}
      showSwitcher={false}
      cardTitle="Ссылка недоступна"
      hint="Приглашение истекло, уже использовано или отключено клубом."
    >
      <div className={a.regLinkStateError}>
        <div className={a.regLinkStateErrorIcon} aria-hidden>
          !
        </div>
        <p>{message || "Ссылка недействительна или истекла"}</p>
        <AuthButtonLink to={loginPath}>Ко входу</AuthButtonLink>
      </div>
    </AuthShell>
  );
}
